// Section for import npm components ------------------------------------------------------------------------------------
import React from 'react';

// MUI components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function ReviewItemEmpty() {
  return (
    <Box className="py-4 px-3 max-md:p-0 max-md:py-4 max-md:px-3 border border-border rounded">
      <Typography className="text-rf-black text-sm">このマンションにはまだ口コミがありません</Typography>
    </Box>
  );
}
